import { styles } from '@app/services/app-styles.service';

const card = {
    root: {
        borderRadius: styles().borderRadius,
        shadow: 'none',
    },
};

export default card;
